import { styled } from "@material-ui/core/styles";
import CloseIcon from '@material-ui/icons/Close';
import { useLinked } from "@type-r/react";
import { div, Flex, Input } from "lqx-react/lib";
import React from "react";
import { TargetFieldCard } from "../../../api/targetFieldCard";
import { DigiSelect } from "../../../components/select";
import { StaticFieldItem } from "../../models/import-template-details";
import { importTemplate } from "../../models/import-wizard-constants";

export const StaticSelectOption = ({ staticFieldItem, inBlockStaticFields, onSelectStatic, onDeleteStatic }
  : { staticFieldItem: StaticFieldItem, inBlockStaticFields?: TargetFieldCard[], onSelectStatic: any, onDeleteStatic?: any }) => {

  const selected = inBlockStaticFields.filter(x => x.name == staticFieldItem.fieldName)[0];
  const $dropDownLinked = useLinked(selected).onChange(x => {
    if (Boolean(x) && x.name !== selected.name) {
      const selectedOptionName = x.name !== importTemplate.selectOption.name
        ? inBlockStaticFields.find((item) => item.name === x.name).name
        : importTemplate.selectOption.name;
      onSelectStatic(selectedOptionName, staticFieldItem.value, staticFieldItem.fieldId);
    }
  });

  const $inputLinked = useLinked(staticFieldItem.value)
    .onChange(x => staticFieldItem.value = x);

  return (
    <Flex row>
      <DigiSelect data-qa-id="inBlockStaticFields" id="id" label="name" $value={$dropDownLinked} options={inBlockStaticFields}></DigiSelect>
      <SourceFileColumn>
        <StaticValueInput $value={$inputLinked} placeholder="Static value" />
      </SourceFileColumn>
      <CloseBtn>
        <CloseIcon onClick={() => onDeleteStatic(staticFieldItem.fieldName, staticFieldItem.value, staticFieldItem.fieldId)} />
      </CloseBtn>
    </Flex>
  );
};

const CloseBtn = div({
  marginTop: '5px',
  height: '22px',
  marginLeft: '5px',
  cursor: 'pointer'
});

const StaticValueInput = styled(Input)({
  height: '38px'
});

const SourceFileColumn = div({
  flex: '0 0 257px',
  paddingLeft: '15px',
  color: '#767D84',
  fontSize: '12px',
  fontFamily: 'Montserrat',
  fontWeight: 500,
  alignSelf: 'center',
  marginBottom: '6px'
})